/**
 * Constants for EditQueryModal component
 */

export const PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const STATUS_OPTIONS = [
  { value: 'raised', label: 'Open' },
  { value: 'Delegated', label: 'Delegated' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'additional_clarification', label: 'Additional Clarification' },
  { value: 'escalated', label: 'Escalated' },
  { value: 'closed', label: 'Closed' },
];

export const DEFAULT_FORM_DATA = {
  queryDescription: '',
  visualDescription: '',
  priority: 'medium',
  category: '',
  statusLabel: 'raised',
  statusResponse: '',
  assigneeId: '',
};

export const GLOBAL_ASSIGNMENT_ROLES = ['CH', 'CHAIRPERSON', 'CHAIRMAN', 'ADMIN', 'SYSTEM ADMINISTRATOR'];

export const EXCLUDE_PEERS_ROLES = ['CH', 'CHAIRPERSON', 'CHAIRMAN'];
